import { Box, Grid, Paper, Typography, Chip } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const AiServiceSection = ({ product, index, reverse }) => {
    const imageFirst = !reverse;

    const imageBlock = (
        <Box
            sx={{
                width: '100%',
                borderRadius: '12px',
                overflow: 'hidden',
                border: '1px solid #E9EBED',
                background: 'linear-gradient(145deg, #F5FCFC 0%, #E8EDF2 100%)',
                p: { xs: 2, md: 3 },
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: { xs: 220, md: 280 },
            }}
        >
            <Box
                component="img"
                src={product.image}
                alt={product.imageAlt}
                loading="lazy"
                sx={{
                    width: '100%',
                    maxWidth: 420,
                    height: product.imageFit === 'cover' ? { xs: 220, md: 280 } : 'auto',
                    maxHeight: 280,
                    objectFit: product.imageFit || 'cover',
                    borderRadius: '8px',
                    display: 'block',
                }}
            />
        </Box>
    );

    const contentBlock = (
        <Box>
            <Chip
                label={product.tag}
                size="small"
                sx={{
                    mb: 1.5,
                    fontWeight: 600,
                    backgroundColor: '#E8EDF2',
                    color: '#4A6984',
                    border: '1px solid rgba(74, 105, 132, 0.25)',
                }}
            />
            <Typography
                component="h3"
                variant="h5"
                sx={{ fontWeight: 700, color: '#03363D', mb: 0.5, lineHeight: 1.3 }}
            >
                <Box
                    component="span"
                    sx={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: 32,
                        height: 32,
                        borderRadius: '50%',
                        backgroundColor: '#03363D',
                        color: '#fff',
                        fontSize: '0.95rem',
                        mr: 1.5,
                        verticalAlign: 'middle',
                    }}
                >
                    {index + 1}
                </Box>
                {product.title}
            </Typography>
            <Typography
                variant="body2"
                sx={{ color: 'text.secondary', mb: 2.5, fontStyle: 'italic', pl: { md: 5.5 } }}
            >
                {product.titleEn}
            </Typography>

            <Paper
                elevation={0}
                sx={{
                    p: 2,
                    mb: 2.5,
                    backgroundColor: '#F8F9F9',
                    borderLeft: '4px solid #4A6984',
                    borderRadius: '4px',
                }}
            >
                <Typography
                    sx={{
                        fontWeight: 600,
                        color: '#17494D',
                        fontSize: '0.875rem',
                        mb: 0.75,
                        textTransform: 'uppercase',
                        letterSpacing: '0.04em',
                    }}
                >
                    產品概述
                </Typography>
                <Typography sx={{ lineHeight: 1.8, color: 'text.primary' }}>
                    {product.overview}
                </Typography>
            </Paper>

            <Typography
                sx={{
                    fontWeight: 600,
                    color: '#17494D',
                    mb: 1.5,
                    fontSize: '0.875rem',
                    textTransform: 'uppercase',
                    letterSpacing: '0.04em',
                }}
            >
                核心優勢
            </Typography>
            <Grid container spacing={1.5}>
                {product.advantages.map((item) => (
                    <Grid item xs={12} md={4} key={item.label}>
                        <Box
                            sx={{
                                display: 'flex',
                                gap: 1.5,
                                p: 1.5,
                                borderRadius: '8px',
                                border: '1px solid #E9EBED',
                                backgroundColor: '#FFFFFF',
                                height: '100%',
                            }}
                        >
                            <CheckCircleOutlineIcon
                                sx={{ color: '#4A6984', flexShrink: 0, mt: 0.25 }}
                            />
                            <Box>
                                <Typography
                                    sx={{ fontWeight: 600, color: '#03363D', mb: 0.5 }}
                                >
                                    {item.label}
                                </Typography>
                                <Typography
                                    variant="body2"
                                    sx={{ color: 'text.secondary', lineHeight: 1.7 }}
                                >
                                    {item.text}
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );

    return (
        <Box
            component="section"
            id={product.id}
            sx={{
                mb: { xs: 5, md: 7 },
                scrollMarginTop: '80px',
            }}
        >
            <Grid container spacing={{ xs: 3, md: 5 }} alignItems="center">
                {imageFirst ? (
                    <>
                        <Grid item xs={12} md={5}>
                            {imageBlock}
                        </Grid>
                        <Grid item xs={12} md={7}>
                            {contentBlock}
                        </Grid>
                    </>
                ) : (
                    <>
                        <Grid item xs={12} md={7} sx={{ order: { xs: 2, md: 1 } }}>
                            {contentBlock}
                        </Grid>
                        <Grid item xs={12} md={5} sx={{ order: { xs: 1, md: 2 } }}>
                            {imageBlock}
                        </Grid>
                    </>
                )}
            </Grid>
        </Box>
    );
};

export default AiServiceSection;
